import { QueryObserverOptions, useQuery } from '@tanstack/react-query';
import * as keys from '../../keys/queryKeys';
import api from '../../service';
import { useQueryState } from 'hooks/RQuery/useQueryState';
import useMutateHook from '../../useMutateHook';
import queryKeys, { calendarKeys, pointKeys } from '../../keys/queryKeys';

/* 상수 - wtl */

// 2d 지도 - 옵션
export function getPointsOptions({ siteId }) {
  let options = {
    queryKey: [...keys.pointKeys.wtl.all(siteId)],
    queryFn: () => api.points.wtl.getPoints({ siteId }),
    enabled: !!siteId,
  };

  return options;
}

// 2d 지도 - 쿼리
// 모든 상수 측점
export function usePoints({ siteId }) {
  return useQuery(getPointsOptions({ siteId }));
}

// survey, 측점 타입별로 나눠서 요청
export function useSurveyPoints({ type, siteId, pageSize, pageNum, sort, startDate, endDate, ptNum }) {
  // *type: activeTab (points, joints, holes, valves, fires)
  let params = { siteId, pageSize, pageNum, sort, startDate, endDate, ptNum };

  let querykey: any[] = [];
  let queryFn: any = () => {};
  let options: QueryObserverOptions = {
    enabled: !!siteId,
  };

  if (type === 'points') {
    querykey = [...keys.pointKeys.wtl.survey.all({ siteId, pageSize, pageNum, sort })];
    queryFn = () => api.points.wtl.getSurveyPoints({ ...params });
  }
  if (type === 'joints') {
    querykey = [...keys.pointKeys.wtl.survey.joints({ ...params })];
    queryFn = () => api.points.wtl.getSurveyJoints({ ...params });
  }
  if (type === 'holes') {
    querykey = [...keys.pointKeys.wtl.survey.holes({ ...params })];
    queryFn = () => api.points.wtl.getSurveyHoles({ ...params });
  }
  if (type === 'valves') {
    querykey = [...keys.pointKeys.wtl.survey.valves({ ...params })];
    queryFn = () => api.points.wtl.getSurveyValves({ ...params });
  }
  if (type === 'fires') {
    querykey = [...keys.pointKeys.wtl.survey.fires({ ...params })];
    queryFn = () => api.points.wtl.getSurveyFires({ ...params });
  }

  return useQueryState(querykey, queryFn, options);
}

// survey, 측점 데이터 유무 체크
export function useSurveyPointsFirst({ siteId, facility, pageSize, pageNum, sort, startDate, endDate, ptNum }) {
  // *type: activeTab (points, joints, holes, valves, fires)
  let params = { siteId, facility, pageSize, pageNum, sort, startDate, endDate, ptNum };

  let querykey: any[] = [];
  let queryFn: any = () => {};
  let options: QueryObserverOptions = {
    enabled: !!siteId,
  };

  querykey = [queryKeys.MainKey.SURVEY, siteId, facility];
  queryFn = () => api.points.wtl.getSurveyPoints({ ...params });

  return useQueryState(querykey, queryFn, options);
}

// 상수 - 포인트 상세정보 조회 - 타입별로 조회
export function usePointDetail({ type, pointId }) {
  let querykey: any[] = [];
  let queryFn: any = () => {};
  let options: QueryObserverOptions = {
    enabled: !!pointId,
    //  staleTime: 1000 * 60,
    //  gcTime: Infinity,
  };

  if (type === 'joints') {
    querykey = [...keys.pointKeys.wtl.jointDetail(pointId)];
    queryFn = () => api.points.wtl.getJointDetail(pointId);
  }
  if (type === 'holes') {
    querykey = [...keys.pointKeys.wtl.holeDetail(pointId)];
    queryFn = () => api.points.wtl.getHoleDetail(pointId);
  }
  if (type === 'valves') {
    querykey = [...keys.pointKeys.wtl.valveDetail(pointId)];
    queryFn = () => api.points.wtl.getValveDetail(pointId);
  }
  if (type === 'fires') {
    querykey = [...keys.pointKeys.wtl.fireDetail(pointId)];
    queryFn = () => api.points.wtl.getFireDetail(pointId);
  }
  return useQueryState(querykey, queryFn, options);
}

//Bbox 내 파이프 리스트
export function useSurveyBbox({ pointIds, siteId }) {
  return useQuery({
    queryKey: [...keys.pointKeys.wtl.survey.bbox, { pointIds, siteId }],
    queryFn: () => api.points.wtl.getSurveyBbox({ pointIds, siteId }),
    enabled: !!pointIds,
  });
}

//측량성과 선택 삭제
export function useSurveyDeletePoints({ siteId, pointIds }) {
  return useMutateHook({
    fetchApi: () => api.points.wtl.deleteSurveyPoints({ siteId, pointIds }),
    invalidQuery: [[...calendarKeys.surveyPoints({ siteId })], [...calendarKeys.surveyPipes({ siteId })], [...pointKeys.wtl.common, 'list', { siteId }], [queryKeys.MainKey.SURVEY]],
  });
}

//측량성과 날짜 삭제
export function useSurveyDeletePointsByDate({ siteId, date }) {
  return useMutateHook({
    fetchApi: () => api.points.wtl.deleteSurveyPointsByDate({ siteId, date }),
    invalidQuery: [[...calendarKeys.surveyPoints({ siteId })], [...calendarKeys.surveyPipes({ siteId })], [...pointKeys.wtl.common, 'list', { siteId }], [queryKeys.MainKey.SURVEY]],
  });
}

//측량성과 날짜별 포인트 데이터 조회
export function useSurveyPointsByDate({ siteId, date, workDate }) {
  return useQuery({
    queryKey: [...keys.pointKeys.wtl.survey.date({ siteId, date, workDate })],
    queryFn: () => api.points.wtl.getSurveyPointsByDate({ siteId, date }),
    enabled: !!date,
  });
}
